import { MapPin } from "@/shared/icons";

type Props = {
  location: string;
};

export default function GasStationLocation({ location }: Props) {
  return (
    <div className="flex items-center gap-2.5 p-3.5">
      <MapPin size={20} className="text-accent-solid shrink-0" />
      <div className="text-15 font-medium text-white">{location}</div>
    </div>
  );
}
